import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType, getSimpleBranchingQuery } from '@iotv/datamodel';
import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import { getVisibleGroups } from '../../../helpers/queryHelpers';
import { CardinalityOneCard } from '../../factories/Listerlizer/CardinalityOneCard';
import { SimpleList } from '../../factories/Listerlizer/SimpleList';
import { VisibleGroupsViewDefinition } from '../Devices/DeviceGatewayGroupViewSubParts';
export const UsersGroupsTab = ({ user, transactionFunctions, userFunctions }) => {
    const [usersGroupTree, setUsersGroupTree] = useState();
    const [visibleGroups, setVisibleGroups] = useState([]);
    useEffect(() => {
        getVisibleGroups(user).then((g_res) => {
            if (g_res.err || !g_res.data) {
                console.error('Error loading users visible groups', g_res.err?.message ?? 'No data');
                return;
            }
            setVisibleGroups(g_res.data);
        });
        ConsumerDao.getGraphQueryRequestV2({ query: getSimpleBranchingQuery('User', 'Group', AdjacentType.PARENT), contextObjects: [user] }).then((group_res) => {
            if (group_res.err || !group_res.data) {
                console.error('Error loading users visible groups', group_res.err?.message ?? 'No data');
                return;
            }
            const usersGroups = group_res.data.getNodesOfType('Group');
            if (usersGroups.length > 1) {
                console.warn('More than one group for', user.name, usersGroups);
            }
            setUsersGroupTree(group_res.data);
        });
    }, [user.sk]);
    return (_jsxs(Stack, { gap: 1, children: [_jsxs(Stack, { gap: 0, children: [_jsx(Typography, { variant: "h6", children: "Belongs to Group" }), _jsx(CardinalityOneCard, { matchedPrimary: user,
                        transactionFunctions,
                        userFunctions,
                        adjacentFilter: {
                            adjacentType: AdjacentType.PARENT,
                            objectType: 'Group',
                            groupSupportedType: 'User',
                        },
                        applicationData: usersGroupTree })] }), _jsxs(Stack, { gap: 0, children: [_jsx(Typography, { variant: "h6", children: "Visible Groups" }), _jsx(SimpleList, { listItems: visibleGroups, viewDefinition: VisibleGroupsViewDefinition, sortModel: [{ field: 'supportedType', sort: 'asc' }] })] })] }));
};
